import { render, staticRenderFns } from "./AddFileModal.vue?vue&type=template&id=c7cd1ffc&scoped=true&"
import script from "./AddFileModal.vue?vue&type=script&lang=js&"
export * from "./AddFileModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7cd1ffc",
  null
  
)

export default component.exports